export enum PatientAffiliateSubscriptionStatusIDEnum {
  Current = 0,
  PaymentError = 1,
  Canceled = 2,
}
